// removed by extract-text-webpack-plugin
module.exports = {"Button":"src-componentsEn-Button----Button-module---Button---2JTlm","Primary":"src-componentsEn-Button----Button-module---Primary---_dSAO","PrimaryButtonLoading":"src-componentsEn-Button----Button-module---PrimaryButtonLoading---1p514","PrimaryButtonDisabled":"src-componentsEn-Button----Button-module---PrimaryButtonDisabled---D3iR5","Secondary":"src-componentsEn-Button----Button-module---Secondary---aGVMu","Transparent":"src-componentsEn-Button----Button-module---Transparent---3PMbj"};


//////////////////
// WEBPACK FOOTER
// ./src/componentsEn/Button/Button.module.css
// module id = 38
// module chunks = 1135276415346 81697171470250 109720526809499 114276838955818